import mask from './mask'
import regMiddleHeader from './reg-middle-header'
import header from './header'
import section from './section'
import title from './title'
import submit from './submit'
import dateSelect from './date-select'
import select from './select'
import uploadImg from './upload-img'
import applyFlow from './apply-flow'
import processFlow from './process-flow'
import radio from './radio'
import button from './button'
import citySelect from './city-select'
import imgHeader from './img-header'
import itemList from './item-list'
import enrollInfo from './enroll-info'
import enrollFail from './enroll-fail'
import enrollOver from './enroll-over'
import share from './share'
import carousel from './carousel'
import val from './val.vue'
import main from './main'
import Vue from 'vue'

export default function () {
  Vue.component('ucar-mask', mask)
  Vue.component('ucar-middle-header', regMiddleHeader)
  Vue.component('ucar-header', header)
  Vue.component('ucar-section', section)
  Vue.component('ucar-title', title)
  Vue.component('ucar-submit', submit)
  Vue.component('ucar-date-select', dateSelect)
  Vue.component('ucar-select', select)
  Vue.component('ucar-upload-img', uploadImg)
  Vue.component('ucar-apply-flow', applyFlow)
  Vue.component('ucar-process-flow', processFlow)
  Vue.component('ucar-radio', radio)
  Vue.component('ucar-button', button)
  Vue.component('ucar-city-select', citySelect)
  Vue.component('ucar-img-header', imgHeader)
  Vue.component('ucar-item-list', itemList)
  Vue.component('ucar-enroll-info', enrollInfo)
  Vue.component('ucar-enroll-fail', enrollFail)
  Vue.component('ucar-enroll-over', enrollOver)
  Vue.component('ucar-share', share)
  Vue.component('ucar-carousel', carousel)
  Vue.component('ucar-val', val)
  Vue.component('ucar-main', main)
}
